import { useDispatch } from "react-redux"
import { StoreState } from "./StoreState"
import { AnyAction } from "redux"
import { ThunkDispatch } from "redux-thunk"

export type ReduxDispatch = ThunkDispatch<StoreState, any, AnyAction>
export default function useReduxDispatch() {
    return useDispatch<ReduxDispatch>()
}
